import axios from "axios";
import { API_URL } from "./index";
class ContactService {
    getContact = (id) => {
        const url = API_URL.contact(id);
        return axios.get(url).then((response) => response);
    };

    getContactByName = (namePattern) => {
        const url = API_URL.contact("find-by-name");
        return axios.get(url, {
            params: {
                namePattern,
                maxResults: 20,
                lookupType: 3,
            },
        });
    };

    getContactRoles = () => {
        const url = API_URL.contactRole();
        const test = axios.get(url).then((response) => response.data);
        return test;
    };

    saveContact = (contact) => {
        const url = API_URL.contact();
        const test = axios.post(url, contact).then((response) => response.data);
        return test;
    };

    editContact = (contact) => {
        const url = API_URL.contact();
        return axios.put(url, contact).then((response) => response.data);
    };

    removeContact = (id) => {
        const url = API_URL.contact(id);
        return axios.delete(url).then((response) => response.data);
    };
}

export default new ContactService();
